// https://blog.ourcade.co/posts/2020/phaser3-how-to-communicate-between-scenes/

class GlobalInfo extends Phaser.Events.EventEmitter {
    _gameProgress: {
        [index: string]: any
    }

    constructor() {
        super()

        // initial state from global info
        this._gameProgress = {
            // habilities to unblock
            canBark: false,
            canSniff: false,
            coins: 0,
            health: 100,
            // true pendant un dialogue : gèle le déplacement + les interactions (cf. Characters.ts).
            inDialogue: false,
            // id de la scène de jeu actuellement éveillée (piloté par ControlsScene sur mobile).
            activeScene: '',
            // zones-écran des contrôles tactiles ([{x,y,w,h}]) : GameScene les ignore pour le tap-Kazi.
            controlZones: undefined,
            // direction courante du joystick ('up'|'down'|'left'|'right'|null) : déclenche les portes.
            moveDir: null
            // here all info you want global
        }


        Object.keys(this._gameProgress).forEach(key => {
            this.on(key, (args: boolean) => {
                this._gameProgress[key] = args
            })
        })

    }
}

export default new GlobalInfo()